import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login, setToken } from "../lib/api";
import { toast } from "sonner";

const Login = () => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token } = await login(password);
      setToken(token);
      nav("/");
    } catch {
      toast("Access denied", { description: "Invalid password." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative" data-testid="login-screen">
      <div className="max-w-md w-full relative z-10">
        <div className="mb-10">
          <div className="op-microcopy mb-3 text-[#00E5FF]">OPERATOR OS · V1</div>
          <h1 className="text-white text-4xl md:text-5xl font-light tracking-tight leading-tight">
            Executive<br />command center.
          </h1>
          <p className="text-[#A0A5B5] mt-4">Private access only.</p>
        </div>

        <form onSubmit={submit} className="op-panel op-panel--glow p-8 space-y-6">
          <div>
            <div className="op-microcopy mb-2">ACCESS KEY</div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              data-testid="login-password"
              autoFocus
              className="op-input op-mono tracking-[0.3em]"
            />
          </div>
          <button
            type="submit"
            disabled={loading || !password}
            data-testid="login-submit"
            className="op-btn op-btn--primary w-full disabled:opacity-40"
          >
            {loading ? "AUTHENTICATING…" : "ENTER"}
          </button>
          <div className="flex items-center justify-between pt-2">
            <div className="flex items-center gap-2">
              <span className="op-pulse-dot" />
              <span className="op-tag">SYSTEM ONLINE</span>
            </div>
            <span className="op-tag">ANTWAN · OPERATOR</span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
